"use client"

import type React from "react"
import { useState, useCallback } from "react"
// import Header from "../../components/DashboardHeader/DashboardHeader"
// import Sidebar from "../../components/DashboardSidebar/DashboardSidebar"

// Components
import ProfilePhotoUpload from "./ProfilePhotoUpload"
import UserDetailsForm from "./UserDetailsForm"
import ChangePasswordForm from "./ChangePasswordForm"

import "./AccountDetails.css"

const AccountDetails: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  const toggleSidebar = useCallback(() => {
    setSidebarCollapsed((prev) => !prev)
  }, [])

  // const handleDemoClick = useCallback(() => {
  // }, [])

  return (
    <div className="account-details-container">
      {/* <Header onToggleSidebar={toggleSidebar} onDemoClick={handleDemoClick} /> */}

      <div className="account-details-content">
        {/* <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} /> */}

        <div className={`account-main-content ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}>
          <div className="account-form-wrapper">
            <div className="page-header">
              <h1 className="page-title">Account Details</h1>
              <p className="page-description">Manage your account information and security settings</p>
            </div>

            <div className="form-sections">
              <ProfilePhotoUpload />
              <UserDetailsForm />
              <ChangePasswordForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountDetails
